import SliderImages from './SliderImages'

export default SliderImages
